// src/components/Loader.tsx

import { useEffect, useState } from "react";

const Loader = () => {
  const words = ["Loading", "Please wait", "Almost there", "Just a moment"];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex(prevIndex => (prevIndex + 1) % words.length);
    }, 2000); // Change word every 2 seconds

    return () => clearInterval(interval);
  }, []); // Empty dependency array since words is constant

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white bg-opacity-90 backdrop-blur-sm">
      <div className="relative mb-6 size-20 flex items-center justify-center">
        {/* Logo - Hidden until loaded to prevent alt text flash */}
        {!imageError ? (
          <img 
            src="/images/botbat-logo.png" 
            alt=""
            role="presentation"
            className={`size-20 relative z-10 object-contain transition-opacity duration-300 ${
              imageLoaded ? "opacity-100" : "opacity-0"
            }`}
            onLoad={() => setImageLoaded(true)}
            onError={() => {
              setImageError(true);
            }}
            style={{ display: imageLoaded ? "block" : "none" }}
          />
        ) : null}
        {/* Fallback: Text logo (shown if image fails to load) */}
        {imageError && (
          <div className="size-20 relative z-10 flex items-center justify-center bg-gradient-to-br from-blue-500 to-primary-600 rounded-full">
            <span className="text-white text-2xl font-bold">B</span>
          </div>
        )}
        {/* Spinning border overlay */}
        <div className="absolute inset-0 size-20 animate-spin rounded-full border-4 border-dashed border-blue-500 border-t-transparent pointer-events-none"></div>
      </div>
      {/* Loading text with smooth transition */}
      <div className="h-8 flex items-center">
        <p className="text-lg font-semibold text-blue-500 transition-opacity duration-500">
          {words[currentWordIndex]}
        </p>
      </div>
    </div>
  );
};

export default Loader;
